import { DASHBOARD_ROLES, JwtPayload, Role } from "../types/auth.type";

export const hasAnyRole = (payload: JwtPayload | null | undefined, roles: Role[]) =>
  Array.isArray(payload?.roles) && roles.some((r) => payload!.roles!.includes(r));

export const checkIsAdmin = (payload: JwtPayload | null | undefined) =>
  hasAnyRole(payload, [Role.ADMIN]);

export const checkIsManager = (payload: JwtPayload | null | undefined) =>
  hasAnyRole(payload, [Role.MANAGER]) && !checkIsAdmin(payload);

export const checkIsCoach = (payload: JwtPayload | null | undefined) =>
  hasAnyRole(payload, [Role.COACH]) && !checkIsAdmin(payload) && !checkIsManager(payload);

export const hasDashboardAccess = (payload: JwtPayload | null | undefined) =>
  hasAnyRole(payload, DASHBOARD_ROLES);

export const getHomeRoute = (
  isAdmin: boolean,
  isManager: boolean,
  isCoach: boolean
) => {
  if (isAdmin) return "/users";
  if (isManager) return "/schedule";
  if (isCoach) return "/workouts";
  return "/login";
};
